import React, { useEffect, useState } from 'react';
import { 
    Button, 
    MenuItem, 
    Snackbar, 
    TextField, 
    Alert, 
    Stack, 
    Grid,
    Box
} from '@mui/material';
import ApiServices from '../services/ApiServices';
export default function SelectionForm({ handleSubmit, selectedDevices, isErrorTrue }) {
    const [versionOptions, setVersionOptions] = useState({
        bootloader: [],
        firmware: [],
        firmware_v2: [],
        firmware_v3: []
    });

    const [formValues, setFormValues] = useState({
        bootloader: '',
        firmware: '',
        firmware_v2: '',
        firmware_v3: ''
    });

    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        severity: "info",
    });
    
    useEffect(() => {
        const fetchAllVersions = async () => {
            try {
                
                const [bootloader, fw1, fw2, fw3] = await Promise.all([
                    ApiServices.fetchVersionsFromType("bootloader"),
                    ApiServices.fetchVersionsFromType("firmware"),
                    ApiServices.fetchVersionsFromType("firmware_v2"),
                    ApiServices.fetchVersionsFromType("firmware_v3")
                ]);

                
                setVersionOptions({
                    bootloader: Array.from(new Set(bootloader.data)),
                    firmware: Array.from(new Set(fw1.data)),
                    firmware_v2: Array.from(new Set(fw2.data)),
                    firmware_v3: Array.from(new Set(fw3.data)),
                });
            } catch (error) {
                console.error("Failed to fetch versions:", error);
                showSnackbar("Error fetching versions", "error");
                setVersionOptions({ bootloader: [], firmware: [], firmware_v2: [], firmware_v3: [] });
            }
        };

        fetchAllVersions();
    }, []);
    const showSnackbar = (message, severity) => {
        setSnackBar({ open: true, message, severity });
    };

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackBar(prev => ({ ...prev, open: false }));
    };
    const handleChange = (key) => (e) => {
        const value = e.target.value;
        if (value.includes("Not Released")) {
            showSnackbar("You are flashing not released binary.", "error");
        }
        setFormValues(prev => ({ ...prev, [key]: value }));
    };

    const copyImeis = (e) => {
        e.preventDefault();
        const textToCopy = Array.from(selectedDevices).join(',');
        navigator.clipboard.writeText(textToCopy);
        showSnackbar("Copied.", "success");
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const req = {};
        Object.keys(formValues).forEach(key => {
            const val = formValues[key];
            if (val && val.length > 1) {           
                req[key] = val.includes("Not Released") 
                    ? val.replace('Not Released', '').trim() 
                    : val;
            }
        });      
        req["deviceList"] = Array.from(selectedDevices);
        handleSubmit(req);
    };    
    const formFields = [
        { key: 'bootloader', label: 'Bootloader Version', list: versionOptions.bootloader },
        { key: 'firmware', label: 'Firmware IoT1', list: versionOptions.firmware },
        { key: 'firmware_v2', label: 'Firmware IoT2', list: versionOptions.firmware_v2 },
        { key: 'firmware_v3', label: 'Firmware IoT3', list: versionOptions.firmware_v3 },
    ];    
    const hasSelection = Object.values(formValues).some(val => val !== "");
    return (
        <Box sx={{ width: '100%' }}>            
            {isErrorTrue && isErrorTrue.length > 0 && (
                <Alert variant="filled" sx={{ mb: 2 }} severity="error">
                    {isErrorTrue}
                </Alert>
            )}
            <Stack sx={{ width: '100%' }}>
                <Snackbar 
                    open={snackBar.open} 
                    autoHideDuration={3000} 
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }} 
                    onClose={handleCloseSnack}
                >
                    <Alert onClose={handleCloseSnack} severity={snackBar.severity} variant="filled" sx={{ width: '100%' }}>
                        {snackBar.message}
                    </Alert>
                </Snackbar>
            </Stack>
            <form onSubmit={handleFormSubmit}>                
                <Box sx={{ mb: 2 }}>
                    <Button onClick={copyImeis} variant="outlined" size="small" sx={{ mb: 1 }}>Copy</Button>
                    <TextField
                        multiline
                        minRows={8}
                        maxRows={8}
                        fullWidth
                        disabled
                        value={Array.from(selectedDevices).join(', ')}
                        placeholder="Empty"
                        variant="outlined"
                    />
                </Box>
                <Grid container spacing={2}>
                    {formFields.map((field) => (
                        <React.Fragment key={field.key}>
                            <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center' }}>
                                <label style={{ fontWeight: 500 }}>{field.label}</label>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    select
                                    fullWidth
                                    label={field.label}
                                    value={formValues[field.key]}
                                    onChange={handleChange(field.key)}
                                    size='small'
                                >
                                    <MenuItem value="">
                                        <em>select the value</em>
                                    </MenuItem>
                                    {field.list.map((version, index) => (
                                        <MenuItem key={index} value={version}>{version}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>                
                {hasSelection && (
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button 
                            size="small" 
                            variant="contained" 
                            color="primary" 
                            type='submit'
                        >
                            Submit
                        </Button>
                    </Box>
                )}
            </form>
        </Box>
    );
}